import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";

import DashboardLayout from "@/components/layout/DashboardLayout";
import StripeConnectBanner from "@/components/StripeConnectBanner";
import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";
import {
  ClientsKeys,
  getLicenseeClients,
} from "@/features/clients/api/clients";
import AddClientSheet from "@/features/clients/components/AddClientSheet";
import ClientsTable from "@/features/clients/components/ClientsTable";
import { useStripeStatus } from "@/hooks/useStripeStatus";
import { track } from "@/utils/mixpanel";

const Clients = () => {
  const { stripeActive, stripeConnectUrl } = useStripeStatus();
  const [isAddClientOpen, setIsAddClientOpen] = useState(false);

  const { data: clients = [], isLoading } = useQuery({
    queryKey: [ClientsKeys.Clients],
    queryFn: getLicenseeClients,
  });

  const handleAddClientClick = () => {
    setIsAddClientOpen(true);
    track("start_add_client");
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div>
            <Typography size="h2" className="text-[#1e1e24]">
              Clients
            </Typography>
            <Typography size="b2" className="text-[#767677]">
              Manage your leads and clients in one place.
            </Typography>
          </div>
          <Button
            variant="ghost"
            className="h-9 rounded-lg px-5 border border-[#e8e8e8] text-[#1e1e24] hover:bg-transparent w-full sm:w-auto"
            onClick={handleAddClientClick}
          >
            <Plus className="mr-2 h-4 w-4" /> Add a new client
          </Button>
        </div>

        {/* Stripe Connect Banner - shown when not connected */}
        {!stripeActive && (
          <StripeConnectBanner connectUrl={stripeConnectUrl} />
        )}

        <div className="bg-[#f9f9f9] rounded-2xl p-4 sm:p-6">
          <Typography size="l2" className="font-semibold text-[#767677]">
            Directory
          </Typography>
          <div className="mt-4 sm:bg-[#fdfdfd] sm:p-2">
            <ClientsTable clients={clients} isLoading={isLoading} />
          </div>
        </div>
      </div>

      <AddClientSheet
        isOpen={isAddClientOpen}
        onClose={() => setIsAddClientOpen(false)}
      />
    </DashboardLayout>
  );
};

export default Clients;
